import styled, { css } from 'styled-components';
import { marginStyles } from '../../styles/components.js';
import { mapBackgroundToContentColor } from '../../utils/color-mapper.js';
import 'react';

const getPadding = (size) => {
    if (size === 'xsmall') {
        return '8px';
    }
    else if (size === 'small') {
        return '6px 8px';
    }
    else {
        return '5px 8px';
    }
};
const backgroundless = (props) => props.color &&
    css `
    background: none;
    color: ${props.theme.colors.content[props.color]};
    border: 1px solid ${props.theme.colors.content[props.color]};
  `;
const StyledBadge = styled.div `
  background: ${props => props.theme.colors.background[props.backgroundColor]};
  border-radius: 12px;
  color: ${props => mapBackgroundToContentColor({
    backgroundColor: props.backgroundColor,
    theme: props.theme,
})};
  display: inline-block;
  line-height: 100%;
  font-family: ${props => props.theme.fontFamilies.main.medium};
  -webkit-font-smoothing: antialiased;
  font-size: ${props => props.size === 'medium'
    ? props.theme.fontSizes[400]
    : props.theme.fontSizes[300]};
  padding: ${props => getPadding(props.size)};
  text-align: center;
  white-space: nowrap;

  ${props => marginStyles(props.margin)};

  ${props => props.backgroundless && backgroundless}
`;

export { StyledBadge };
